const StorageType ={
  local: 'local',
  session: 'session',
  cookie: 'cookie'
}
export default StorageType
